import { render, staticRenderFns } from "./RemoteDownload.vue?vue&type=template&id=6c6585cb&scoped=true"
import script from "./RemoteDownload.vue?vue&type=script&lang=js"
export * from "./RemoteDownload.vue?vue&type=script&lang=js"
import style0 from "./RemoteDownload.vue?vue&type=style&index=0&id=6c6585cb&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6585cb",
  null
  
)

export default component.exports